// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles__heading___2iLPN","footer":"styles__footer___2Hbt2","progress":"styles__progress___1mdOC","container":"styles__container___oBLNU"};